import { AxiosResponse } from 'axios'

import ClientSDK from '../../../App/ClientSDK'
import { IUser } from '../../../User/DataStore/IUser'

import { IApiPunchclockTime, IPunchclockTime } from './IPunchclockTime'
import Transformer from './Transformer'

class Client {
  static getPunchclockTimes = (): Promise<IPunchclockTime[]> =>
    ClientSDK.instance()
      .get('punchclock/times')
      .then((response: AxiosResponse): IPunchclockTime[] => {
        return response.data.data.map((data: IApiPunchclockTime) =>
          Transformer.transform(data),
        )
      })

  static startPunchclockTime = (user: IUser): Promise<IPunchclockTime> =>
    ClientSDK.instance()
      .post('punchclock/start', { person_id: user.id })
      .then((response: AxiosResponse): IPunchclockTime => {
        return Transformer.transform(response.data.data)
      })

  static endPunchclockTime = (user: IUser): Promise<IPunchclockTime> =>
    ClientSDK.instance()
      .post('punchclock/end', { person_id: user.id })
      .then((response: AxiosResponse): IPunchclockTime => {
        return Transformer.transform(response.data.data)
      })
}

export default Client
